export type InspectionDashboardGrain = "shift" | "day" | "month";

export interface InspectionDashboardTotals {
	Sheets: number;
	SheetsWithFinding: number;
	Readings: number;
	ReadingsWithNoGo: number;
	ReadingsWithDefect: number;
	ChecksRecorded: number;
	FailedChecks: number;
	Defects: number;
}

export interface InspectionDashboardBucketKey {
	BucketStartUtc: Date;
	ProductionDate: Date | null;
	Shift: string | null;
}

export interface InspectionDashboardBucket
	extends InspectionDashboardBucketKey {
	BucketOrdinal: number;
	Readings: number;
	ReadingsWithNoGo: number;
	ReadingsWithDefect: number;
}

export interface InspectionDashboardDefect {
	SurfaceDefectId: number | null;
	SurfaceDefectName: string;
	Color: string | null;
	DefectCount: number;
}

export interface InspectionDashboardDefectTrendPoint
	extends InspectionDashboardBucketKey {
	BucketOrdinal: number;
	TopRank: number;
	SurfaceDefectId: number | null;
	SurfaceDefectName: string;
	Color: string | null;
	BucketDefects: number;
	DefectCount: number;
}

export interface InspectionDashboardSection {
	SectionId: number;
	SectionName: string;
	Readings: number;
	ChecksRecorded: number;
	FailedChecks: number;
	Defects: number;
}

export interface InspectionDashboardHeat {
	HeatId: number;
	HeatName: string;
	Readings: number;
	ChecksRecorded: number;
	FailedChecks: number;
	Defects: number;
}

export interface InspectionDashboard {
	grain: InspectionDashboardGrain;
	totals: InspectionDashboardTotals;
	buckets: InspectionDashboardBucket[];
	defects: InspectionDashboardDefect[];
	sections: InspectionDashboardSection[];
	heats: InspectionDashboardHeat[];
	defectTrend: InspectionDashboardDefectTrendPoint[];
}

export const EMPTY_INSPECTION_DASHBOARD_TOTALS: InspectionDashboardTotals = {
	Sheets: 0,
	SheetsWithFinding: 0,
	Readings: 0,
	ReadingsWithNoGo: 0,
	ReadingsWithDefect: 0,
	ChecksRecorded: 0,
	FailedChecks: 0,
	Defects: 0,
};
